import { ConsultationRequests } from "../components";

export const ConsultationRequestsScreen = () => <ConsultationRequests />;
